import React from 'react';
import { filterData } from '../data';

const Filter = (props) => {
   function filterHandler(t)
   {
    props.setCat(t);
   }
    return (
        <div className='w-11/12 flex flex-wrap max-w-max space-x-4 mx-auto justify-center'>
            {filterData.map((data)=>{
                return (
                    <button
                    onClick={() => filterHandler(data.title)}

                     className={`text-lg px-2 py-1  my-2 rounded font-medium text-white bg-black hover:bg-opacity-75 
                     ${ data.title === props.cat ? "border-white border-2 ":"border-0"}`}

                      key={data.id}
                      >
                        {data.title}
                    </button>
                );
                })}
        </div>
    );
}

export default Filter;
